import { ProductDetail, ProductSize } from '../types/types';

interface ProductLDScriptProps {
  productDetail: ProductDetail
}

export const ProductLDScript = ({ productDetail }: ProductLDScriptProps) => {
  const {
    productId,
    productCode,
    brandName,
    productName,
    currentPrice,
  } = productDetail;

  // const title = `${brandName}-${productName} ${currentPrice} | WORKSOUT`;
  const description = `브랜드 : ${brandName} 제품아이디: ${productId} 제품번호 : ${productCode} 제품 : ${productName} - ${currentPrice.toLocaleString()}`;
  const url = `https://www.carhartt-wip.co.kr/product/${productId}`;
  const image = productDetail.images[0]?.thumbnailUrl;

  // 페이스북 가이드에 따르면 다음 값들 중 하나를 사용하라고 합니다.
  // "in stock", "out of stock", "preorder", "available for order", "discontinued", "pending"
  // 그러나 페이스북의 데이터 예시에서는 다음과 같이 schema.org 도메인으로 값을 사용하고 있습니다.
  // { ... "availability": "https://schema.org/InStock" ... }
  //
  // => 그래서 schema.org 도메인을 포함하는 값으로 세팅합니다.
  // => 값은 여러 상태들 중 다음 두 가지 중 하나로 사용합니다.
  // => InStock, OutOfStock
  const availability = ((productSizes: ProductSize[]): string => {
    const currentStock = productSizes.map(size => size.currentStock).reduce((acc, cur) => acc + cur, 0);
    return currentStock > 0
      ? "https://schema.org/InStock"
      : "https://schema.org/OutOfStock";
  })(productDetail.productSizes || []);

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Product",
    "productID": `${productId}`,
    "name": `${productName}`,
    "description": `${description}`,
    "url": `${url}`,
    "image": `${image}`,
    "brand": `${brandName}`,
    "offers": [
      {
        "@type": "Offer",
        "price": `${currentPrice}`,
        "priceCurrency": "KRW",
        // "itemCondition": "https://schema.org/NewCondition",
        "availability": availability
      }
    ],
    // "additionalProperty": [{
    //     "@type": "PropertyValue",
    //     "propertyID": "item_group_id",
    //     "value": "fb_tshirts"
    // }]
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
    />
  )
};
